import React, { useEffect } from "react";
import img1 from "../../assets/image (17).png";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Divider } from "@mui/material";

const ContactPage = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <>
      <div className="bg-gradient-to-r from-[#FFE997] to-[#FFCF1F] text-gray-800">
        {/* Header Section */}
        <div className="text-center py-8  ">
          <h1 className="text-xl md:text-4xl font-bold text-[#ED1C24] headingfont">
            GET IN TOUCH WITH US. WE'RE HERE TO ASSIST YOU
          </h1>
        </div>

        {/* Main Section */}
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 px-6 py-12">
          {/* Contact Information */}
          <div className="space-y-6 p-4 rounded-2xl border-2 border-black transform hover:scale-105 transition-transform duration-300">
            <div className="">
              <h2 className="text-lg font-bold">Registered Office</h2>
              <p className="text-sm font-semibold">
                1E/2, Desh Bandhu Gupta Road, Jhandewalan Extension, New Delhi
                110055
              </p>
            </div>
            <Divider className="bg-black" />
            <div className="">
              <h2 className="text-lg font-bold">Corporate Office</h2>
              <p className="text-sm font-semibold">
                Unitech Cyber Park, Tower D, 9th Floor, Sector 39, Gurugram
                122003
              </p>
            </div>
            <Divider className="bg-black" />

            <div>
              <h3 className="text-lg font-bold">Call Us</h3>
              <p className="text-sm font-semibold">
                Monday - Friday, 10:00 AM - 6:00 PM
              </p>
              <p className="text-sm font-semibold">+91-8595202302</p>
            </div>
            <Divider className="bg-black" />

            <div className="mt-4">
              <h3 className="text-lg font-bold">Email Support</h3>
              <p className="text-sm font-semibold">
                communications@accessassist.in
              </p>
            </div>
            <Divider className="bg-black" />
            <div className="flex space-x-4 mt-4 justify-center ">
              <a
                href="#"
                className="text-blue-600 hover:text-blue-800 transition"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
              <a
                href="#"
                className="text-blue-400 hover:text-blue-600 transition"
                aria-label="Twitter"
              >
                <TwitterIcon />
              </a>
              <a
                href="#"
                className="text-blue-700 hover:text-blue-900 transition"
                aria-label="LinkedIn"
              >
                <LinkedInIcon />
              </a>
              <a
                href="#"
                className="text-pink-600 hover:text-pink-800 transition"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          {/* Map Section */}
          <div className="w-full rounded-2xl overflow-hidden border-2 border-black h-[350px] lg:h-[450px]" >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.3930357993568!2d77.19867427613764!3d28.647948083379376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfd66d9662f3d%3A0x19a7d3c0376b0522!2s1e%2C%20310%2F2%2C%20Desh%20Bandhu%20Gupta%20Rd%2C%20Karol%20Bagh%2C%20New%20Delhi%2C%20Delhi%2C%20110055!5e0!3m2!1sen!2sin!4v1755082416584!5m2!1sen!2sin"
               width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>

      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 px-6 py-12">
        {/* Image Section */}
        <div className="flex justify-center items-center ">
          <img
            width={450}
            src={img1}
            alt="Contact"
            className="transform hover:scale-105 transition-transform duration-300"
          />
        </div>

        {/* Form */}
        <div className="bg-gradient-to-br from-[#E7ECFF] to-[#D1D8FF] p-8 rounded-3xl shadow-lg ">
          <h2 className="text-2xl font-extrabold mb-6 text-[#ED1C24] text-center">
            Get in Touch with Us
          </h2>
          <form className="space-y-6">
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-semibold text-gray-800"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                className="mt-2 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-red-400 text-gray-900 sm:text-base px-4 py-2"
                placeholder="Your name"
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-semibold text-gray-800"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                className="mt-2 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-red-400 text-gray-900 sm:text-base px-4 py-2"
                placeholder="example@company.com"
              />
            </div>
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-semibold text-gray-800"
              >
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                className="mt-2 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-red-400 text-gray-900 sm:text-base px-4 py-2"
                placeholder="+91 000 000 0000"
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-semibold text-gray-800"
              >
                Message
              </label>
              <textarea
                id="message"
                rows="4"
                className="mt-2 block w-full border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-red-400 text-gray-900 sm:text-base px-4 py-2"
                placeholder="Leave us a message"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-red-500 to-red-700 text-white py-3 px-6 rounded-lg text-lg font-semibold shadow-md hover:shadow-lg hover:from-red-600 hover:to-red-800 transition-transform duration-300 transform hover:-translate-y-1"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
